var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 22L8.5 14.5L10.6 12.325L14.5 16.225V4H17.5V16.225L21.4 12.325L23.5 14.5L16 22ZM7 28C6.175 28 5.469 27.7065 4.882 27.1195C4.295 26.5325 4.001 25.826 4 25V20.5H7V25H25V20.5H28V25C28 25.825 27.7065 26.5315 27.1195 27.1195C26.5325 27.7075 25.826 28.001 25 28H7Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.112e5ce85cc9271b356051f2a6e0b4d5.svg";
export { ForwardRef as ReactComponent };